import { render, staticRenderFns } from "./RedemptionReinvestmentSuccess.vue?vue&type=template&id=12820962&scoped=true"
import script from "./RedemptionReinvestmentSuccess.vue?vue&type=script&lang=js"
export * from "./RedemptionReinvestmentSuccess.vue?vue&type=script&lang=js"
import style0 from "./RedemptionReinvestmentSuccess.vue?vue&type=style&index=0&id=12820962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12820962",
  null
  
)

export default component.exports